import { ADS_CAMPAIGN_STATUS_DRAFT } from "../../../utils/constants";

const EMPTY_BUCKET = {
  impressions: 0,
  clicks: 0,
  mainAction: 0,
  spend: {},
};

const addToSpendByCurrency = (spendMap, amount, currency) => {
  if (!currency || !amount) {
    return spendMap;
  }

  const next = { ...spendMap };
  next[currency] = (Number(next[currency]) || 0) + Number(amount);
  return next;
};

/**
 * Aggregates per-campaign unified daily series into portfolio-level buckets.
 * @returns {{ portfolioBuckets: Array, buckets: Array<{ startDateTime, endDateTime }> }}
 */
export const aggregatePortfolioTimeSeries = ({
  campaigns = {},
  statistics = {},
  dispatch,
  getCurrencyForPlatform,
}) => {
  const campaignsStats = statistics?.campaigns || {};
  let buckets = [];

  Object.keys(campaigns).forEach((campaignID) => {
    if (buckets.length) {
      return;
    }

    const campaign = campaigns[campaignID];
    if (campaign?.states?.general === ADS_CAMPAIGN_STATUS_DRAFT) {
      return;
    }

    const unifiedCampaign = campaignsStats[campaignID];
    if (!unifiedCampaign) {
      return;
    }

    (unifiedCampaign.platforms || []).forEach((platform) => {
      if (buckets.length) {
        return;
      }

      const campaignBuckets =
        unifiedCampaign?.levels?.campaign?.daily?.[platform]?.campaign || [];

      if (campaignBuckets.length) {
        buckets = campaignBuckets.map((bucket) => ({
          startDateTime: bucket?.startDateTime,
          endDateTime: bucket?.endDateTime,
        }));
      }
    });
  });

  const bucketCount = buckets.length;

  if (!bucketCount) {
    return { portfolioBuckets: [], buckets: [] };
  }

  const portfolioBuckets = Array.from({ length: bucketCount }, () => ({
    ...EMPTY_BUCKET,
    spend: {},
  }));

  Object.keys(campaigns).forEach((campaignID) => {
    const campaign = campaigns[campaignID];

    if (campaign?.states?.general === ADS_CAMPAIGN_STATUS_DRAFT) {
      return;
    }

    const unifiedCampaign = campaignsStats[campaignID];
    if (!unifiedCampaign) {
      return;
    }

    (unifiedCampaign.platforms || []).forEach((platform) => {
      const campaignBuckets =
        unifiedCampaign?.levels?.campaign?.daily?.[platform]?.campaign || [];
      const platformData = campaign?.platformsData?.[platform] || {};

      campaignBuckets.forEach((bucket, index) => {
        if (index >= bucketCount) {
          return;
        }

        const metrics = bucket?.value || {};
        const impressions = Number(metrics.impressions || 0);
        const clicks = Number(metrics.click || 0);
        const mainAction = Number(metrics.mainAction || 0);
        const spend = Number(metrics.spend || 0);

        portfolioBuckets[index].impressions += impressions;
        portfolioBuckets[index].clicks += clicks;
        portfolioBuckets[index].mainAction += mainAction;

        if (spend > 0) {
          const currency =
            metrics.currency ||
            metrics.account_currency ||
            (typeof getCurrencyForPlatform === "function"
              ? getCurrencyForPlatform({
                  dispatch,
                  platform,
                  platformData,
                  metrics,
                })
              : null) ||
            "USD";

          portfolioBuckets[index].spend = addToSpendByCurrency(
            portfolioBuckets[index].spend,
            spend,
            currency
          );
        }
      });
    });
  });

  return { portfolioBuckets, buckets };
};

export default aggregatePortfolioTimeSeries;
